module.exports = __webpack_public_path__ + "docs/img/mountains.c4a69365.png";